import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
    text: {
        '&&': {
            fontFamily: `'Rubik', sans-serif`
        }
    },
    input: {
        '&&': {
            width: '100%',
            fontFamily: `'Rubik', sans-serif`,
            color: 'white'
        }
    },
    label: {
        '&&': {
            marginTop: 10,
            marginBottom: -10
        }
    },
    button: {
        '&&': {
            fontFamily: `'Rubik', sans-serif`,
            fontSize: 15,
            borderRadius: 15,
            height: 35,
            width: 100,
            color: 'white'
        }
    },
    add: {
        '&&': {
            backgroundColor: '#283136',
            '&:hover':
            {
                backgroundColor: '#283136CC'
            }
        }
    },
    clear: {
        '&&': {
            borderColor: '#283136',
            border: '2px solid #283136',
            '&:hover':
            {
                backgroundColor: 'transparent'
            }
        }
    },
    error: {
        '&&': {
            fontFamily: `'Rubik', sans-serif`,
            color: '#b71c1c'
        }
    },
    radioGroup: {
        '&&': {
            width: '100%',
            transform: 'translateY(10%)'
        },
        '@media (max-width: 500px)': {
            '&&': {
                transform: 'translateX(15%)'
            }
        }
    }
});